var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54883 7.06055C8.84766 7.39258 8.84766 7.89062 8.54883 8.18945L2.17383 14.5645C1.8418 14.8965 1.34375 14.8965 1.04492 14.5645C0.712891 14.2656 0.712891 13.7676 1.04492 13.4688L6.85547 7.6582L1.04492 1.81445C0.712891 1.51562 0.712891 1.01758 1.04492 0.71875C1.34375 0.386719 1.8418 0.386719 2.14062 0.71875L8.54883 7.06055Z",
    fill: "#117249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.243195498a2013b485a9eb1ad345e0c4.svg";
export { ForwardRef as ReactComponent };